import { PredefinedPackage } from 'app/models/predefinedPackageModel'

export const getPredefinedPackage = (status): PredefinedPackage => {
  let predefinedPackage = PredefinedPackage.None

  switch (status) {
    case 1:
      predefinedPackage = PredefinedPackage.WebLite1
      break
    case 2:
      predefinedPackage = PredefinedPackage.Web5
      break
    case 3:
      predefinedPackage = PredefinedPackage.Web20
      break
    case 4:
      predefinedPackage = PredefinedPackage.Web50
      break
    case 5:
      predefinedPackage = PredefinedPackage.Web100
      break
    case 6:
      predefinedPackage = PredefinedPackage.Web250
      break
    case 7:
      predefinedPackage = PredefinedPackage.WebPro
      break
  }

  return predefinedPackage
}
